'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useAuthStore } from '@/lib/stores/auth'
import { useRealtimeAll } from '@/lib/utils/realtime/use-realtime'
import { realtimeManager } from '@/lib/realtime'

/**
 * RealtimeProvider
 *
 * 認証済みの場合のみリアルタイム購読を有効にする。
 * 未認証時・ローディング中・お客様ポータルではWebSocket接続を行わない。
 */
export function RealtimeProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isLoading = useAuthStore((s) => s.isLoading)
  const isCustomerPortal = pathname.startsWith('/customer-portal')

  return (
    <>
      {isAuthenticated && !isLoading && !isCustomerPortal && <RealtimeSubscriptions />}
      {children}
    </>
  )
}

function RealtimeSubscriptions() {
  useRealtimeAll()

  useEffect(() => {
    return () => {
      realtimeManager.unsubscribeAll()
    }
  }, [])

  return null
}
